import {
  SwitchLineInput,
  TextInput,
  SimpleModal,
  Box,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import {
  GreyGrey10,
  GreyGrey100,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular,
  Primary14ExtendedSemiBold
} from '@sequencehq/core-components'
import { ResolvedIntegration } from 'modules/Integrations/domain'
import { useRemoveIntegrationModal } from 'modules/Integrations/view/integrationManagement/IntegrationManagementActions/useRemoveIntegrationModal'

/**
 * TODO: Improve data flow by introducing a context for each of the views (browser, modal, and
 * management) to share the state around, including the service scope.
 */
type RemoveIntegrationModalProps = {
  service: ResolvedIntegration
  onClose: () => void
  onSuccess: (args: { removeLinks: boolean }) => Promise<void>
}

export const RemoveIntegrationModal = (props: RemoveIntegrationModalProps) => {
  const hook = useRemoveIntegrationModal({
    service: props.service,
    onSuccess: props.onSuccess,
    onClose: props.onClose
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      width="410px"
      onClose={props.onClose}
      data-testid="removeIntegrationModal"
      isDestructive
      disableSubmitOnEnter
      cancelButtonText="Cancel"
      submitButtonText={hook.actions.confirm.label}
      submittingButtonText="Uninstalling..."
      submitDisabled={hook.actions.confirm.disabled}
      submitting={hook.actions.confirm.removing}
      onSubmit={async () => {
        await hook.actions.confirm.onClick()
        return false
      }}
    >
      <Grid gridRowGap="16px" paddingTop="16px">
        <GridItem>
          <Box
            {...Primary14ExtendedSemiBold}
            color={GreyGrey100}
            marginBottom="8px"
          >
            Are you sure you’d like to disconnect Sequence from{' '}
            {hook.serviceName}?
          </Box>
          <Box {...Primary13Regular} color={GreyGrey80}>
            This stops all future sync workflows, and removes the connection
            between your current records and {hook.serviceName}.
          </Box>
        </GridItem>
        {hook.fields.removeLinks.visible && (
          <GridItem>
            <SwitchLineInput
              data-testid="removeIntegrationModal.removeLinks"
              allowMultiLineLabel
              text={`Also remove all links between Sequence and ${hook.serviceName}`}
              value={hook.fields.removeLinks.value}
              onChange={hook.fields.removeLinks.onChange}
              styles={{
                label: {
                  ...Primary13SemiBold
                }
              }}
            />
          </GridItem>
        )}
        <Box
          borderRadius="8px"
          backgroundColor={GreyGrey10}
          width="100%"
          padding="12px"
        >
          <Box {...Primary13SemiBold} color={GreyGrey80} marginBottom="16px">
            Type UNINSTALL to continue
          </Box>
          <TextInput
            data-testid="removeIntegrationModal.confirmationField"
            width="100%"
            placeholder="UNINSTALL"
            onKeyPress={hook.fields.confirmationField.onKeyPress}
            value={hook.fields.confirmationField.value}
            onChange={hook.fields.confirmationField.onChange}
          />
        </Box>
      </Grid>
    </SimpleModal>
  )
}
